export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'first_name', label: 'First Name' },
  { name: 'last_name', label: 'Last Name' },
  { name: 'email', label: 'Email' },
  { name: 'is_admin', label: 'Admin', type: 'boolean' }
]



// WEBPACK FOOTER //
// ./src/fields/users.js